import React from 'react';

export const PTFlagArt: React.FC = () => (
  <>
    <circle cx="10" cy="10" r="10" fill="#408C41" />
    <path
      d="M10.0826 4.5L18.1652 10L10.0826 15.5L2 10L10.0826 4.5Z"
      fill="#FDDF01"
    />
    <circle cx="10" cy="10" r="3" fill="#0C5283" />
  </>
);

PTFlagArt.displayName = 'PTFlagArt';
